import React, { Component } from "react";
import client from "@culturehq/client";
import { ClickClose, PlainButton } from "@culturehq/components";

import { t } from "app/utils";
import { rsvpResponseTypeLabelFrom } from "constants/rsvpResponseTypes";

import ErrorModal from "components/display/ErrorModal";

const RSVP_OPTIONS = [
  { label: t("Yes"), value: "accepted" },
  { label: t("No"), value: "declined" },
  { label: t("Interested"), value: "interested" },
  { label: t("Invited"), value: "invited" }
];

const AttendeeDropdownOptions = React.memo(({ showDropdown, onClick }) => (
  <ul className={`dropdown-menu ${showDropdown ? "active" : "inactive"}`}>
    {RSVP_OPTIONS.map(({ label, value }) => (
      <li key={label}>
        <PlainButton onClick={() => onClick(value)}>
          {label}
        </PlainButton>
      </li>
    ))}
  </ul>
));

class AttendeeDropdown extends Component {
  state = { error: false, showDropdown: false };

  fetchEvent = async () => {
    const { event: { id: eventId }, onEventUpdate } = this.props;

    try {
      const { event } = await client.getEvent({ eventId });
      onEventUpdate(event);
    } catch (error) {
      this.setState({ error });
    }
  };

  handleToggleDropdown = () => {
    this.setState(({ showDropdown }) => ({ showDropdown: !showDropdown }));
  };

  handleHideDropdown = () => {
    this.setState({ showDropdown: false });
  };

  handleErrorClose = () => {
    this.setState({ error: false });
  };

  handleChange = async responseType => {
    const { event: { id: eventId }, rsvp: { id: rsvpId }, onRsvpUpdate } = this.props;

    this.setState({ error: false });

    try {
      const { rsvp } = await client.updateEventRsvp({ rsvpId, responseType, eventId });
      onRsvpUpdate(rsvp);

      this.setState({ showDropdown: false });
      this.fetchEvent();
    } catch (error) {
      this.setState({ error });
    }
  };

  render() {
    const { rsvp } = this.props;
    const { error, showDropdown } = this.state;

    return (
      <>
        <ClickClose className="RSVPDropdown" onClose={this.handleHideDropdown}>
          <div className="Dropdown">
            <div className="dropdown">
              <button
                className="btn btn-default dropdown-toggle"
                type="button"
                onClick={this.handleToggleDropdown}
              >
                {rsvpResponseTypeLabelFrom(rsvp.responseType)}
                <span className="caret" />
              </button>
              <AttendeeDropdownOptions
                onClick={this.handleChange}
                showDropdown={showDropdown}
              />
            </div>
          </div>
        </ClickClose>
        <ErrorModal error={error} onClose={this.handleErrorClose} />
      </>
    );
  }
}

export default AttendeeDropdown;
